import { render, staticRenderFns } from "./PofPieChart.vue?vue&type=template&id=c60c8a88"
import script from "./PofPieChart.vue?vue&type=script&lang=js"
export * from "./PofPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports